import React, { createContext, Component, useContext } from 'react'
import config from 'config.js'
import { withSnackbar } from 'notistack'
import { restIO } from 'utils/io'
import CustomSnackbar from 'components/CustomSnackbar/CustomSnackbar.jsx';
export const KMSessionUserContext = createContext({
  sessionUserStore: {},
  sessionUserStoreRightPermissionDenied: true,
})
class KMSessionUserProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sessionUserStore: {},
      sessionUserStoreRightPermissionDenied: true,
    }
  }
  componentDidMount() {
    this.initSessionUser()
  }
  async initSessionUser() {
    let { enqueueSnackbar } = this.props
    let endpoint = config.api.session.userss.url
    let responseKeepapi
    try {
      responseKeepapi = await restIO({ endpoint, jwt: true })
    } catch (error) { // network error && 401 not authenticated
      let message = `erreur réseau 202011292135 ${error}`
      enqueueSnackbar(message, { content: (key, message) => <CustomSnackbar id={key} message={message} variant={'error'}  />})
      return false
    }
    let { datas, code } = responseKeepapi
    if (code !== 'ok') {
      let message = `impossible de récuperer la fiche utilisateur. iam policies missing`
      this.setState({ sessionUserStore: {}, sessionUserStoreRightPermissionDenied: true })
       enqueueSnackbar(message, { content: (key, message) => <CustomSnackbar id={key} message={message} variant={'warning'}  />})
      return false
    }
    if (datas.length > 0) {
      let sessionUserStore = datas[0]
      // traitement des droits dynamic https://stackoverflow.com/questions/36517173/how-to-store-a-javascript-function-in-json
      // voir aussi le fichier rbacRules qui serialize en string les fonctions dynamic
      if (sessionUserStore.rbac && sessionUserStore.rbac.dynamic && Array.isArray(sessionUserStore.rbac.dynamic)) {
        sessionUserStore.rbac.dynamic = sessionUserStore.rbac.dynamic.map(dynamic => {
          return JSON.parse(dynamic, (key, value) => typeof value === "string" ? eval("(" + value + ")") : value)
        })
      }
      this.setState({ sessionUserStore, sessionUserStoreRightPermissionDenied: false })
      window.localStorage.setItem("actualRole", sessionUserStore.rbac.roles.find(role => ["collaborator", "collectivityPlurelya", "agent", "supervisor"].includes(role)))
      return true
    }
    return false
  }
  render() {
    return (
      <KMSessionUserContext.Provider value={this.state}>
        {this.props.children}
      </KMSessionUserContext.Provider>
    )
  }
}
export default withSnackbar(KMSessionUserProvider)
export const withSessionUserStore = Component => props => (
  <KMSessionUserContext.Consumer>
    {store => {
      return (<Component {...props} {...store} />)
    }
    }
  </KMSessionUserContext.Consumer>
)
